export default "__VITE_ASSET__D85Yup_u__"